import { render, staticRenderFns } from "./Brow.vue?vue&type=template&id=142e4d28&scoped=true&"
import script from "./Brow.vue?vue&type=script&lang=js&"
export * from "./Brow.vue?vue&type=script&lang=js&"
import style0 from "./Brow.vue?vue&type=style&index=0&id=142e4d28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142e4d28",
  null
  
)

export default component.exports